import { render, staticRenderFns } from "./RegistrationSummaryCardListEntry.vue?vue&type=template&id=562baa8c&"
import script from "./RegistrationSummaryCardListEntry.vue?vue&type=script&lang=ts&"
export * from "./RegistrationSummaryCardListEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports